import { render, staticRenderFns } from "./CTABchecker.vue?vue&type=template&id=49ddfa96&scoped=true"
import script from "./CTABchecker.vue?vue&type=script&lang=js"
export * from "./CTABchecker.vue?vue&type=script&lang=js"
import style0 from "./CTABchecker.vue?vue&type=style&index=0&id=49ddfa96&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49ddfa96",
  null
  
)

export default component.exports